
import axios from 'axios'

export const getMerchants = async (organizationId, programId, params = "") => {
  let url = `/organization/${organizationId}/program/${programId}/merchant?status=1${params}`;

  const response = await axios.get(url);
  return response.data;
};

export const getMerchantCountries = async (organizationId, programId) => {
  let url = `/organization/${organizationId}/program/${programId}/merchant-countries?status=1`;
  const response = await axios.get(url);
  return response.data;
};

export const getMerchantCurrencies = async (organizationId, programId) => {
  let url = `/organization/${organizationId}/program/${programId}/merchant-currency`;
  const response = await axios.get(url);
  return response.data;
};
export const verifyPfiUser = async (programId, merchantId) => {
  const response = await axios.get(`/pfi/program/${programId}/login?merchant_id=${merchantId}`,
    {
      headers: {
        "X-Current-URL": window.location.href
      }
    }
  );
  return response.data; // { verified: true/false, message?: string }
};